import { render } from "./DermatologyExaminationModal.vue?vue&type=template&id=607202ea&scoped=true"
import script from "./DermatologyExaminationModal.vue?vue&type=script&lang=js"
export * from "./DermatologyExaminationModal.vue?vue&type=script&lang=js"

import "./DermatologyExaminationModal.vue?vue&type=style&index=0&id=607202ea&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-607202ea"]])

export default __exports__